._WorkspacesLinks_12vhn_1 {
  display: flex;
  flex-direction: column;
  gap: inherit;
  width: 36ch;
}
